export default __webpack_public_path__ + "assets/images/li-inner-icon-d407fe1d.svg";